import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';
import { Label } from '../../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Search, Edit, Trash2, Plus, TrendingUp } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AdminKnowledge = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchKnowledge();
  }, []);

  const fetchKnowledge = async () => {
    try {
      const response = await axios.get(`${API}/admin/knowledge`);
      setItems(response.data);
    } catch (error) {
      toast.error('Failed to load knowledge base');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen p-8" style={{ backgroundColor: '#0B0F14' }}>
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold mb-8" style={{ color: '#E6EDF3', fontFamily: 'Manrope' }}>
          Knowledge Base Management
        </h2>

        <Card style={{ backgroundColor: '#0F141A', borderColor: '#1F2937' }}>
          <CardHeader>
            <CardTitle style={{ color: '#E6EDF3' }}>Knowledge Items ({items.length})</CardTitle>
          </CardHeader>
          <CardContent>
            {loading ? (
              <p style={{ color: '#94A3B8' }}>Loading...</p>
            ) : items.length === 0 ? (
              <p style={{ color: '#94A3B8' }}>No knowledge items yet. They will be created automatically from successful diagnoses.</p>
            ) : (
              <div className="space-y-3">
                {items.map((item) => (
                  <div
                    key={item.id}
                    className="p-4 rounded-lg"
                    style={{ backgroundColor: '#0B0F14', borderColor: '#1F2937', border: '1px solid' }}
                  >
                    <div className="flex justify-between">
                      <div>
                        <span className="text-xs px-2 py-1 rounded" style={{ backgroundColor: '#1EA0E620', color: '#7CD4FD' }}>
                          {item.source_type}
                        </span>
                        <p className="text-sm mt-2" style={{ color: '#E6EDF3' }}>
                          {item.text.substring(0, 200)}...
                        </p>
                        <p className="text-xs mt-2" style={{ color: '#94A3B8' }}>
                          Score: {item.quality_score?.toFixed(2) || 0}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
